import { AuthorNode } from '@/graphql-fragments/getBlogAuthorsAndReviewers'

type Author = {
  id: string
  fullName: string
  slug: string
  miniBlurb: string
  linkedin: string
}

export const mapAuthorsAndReviewers = (authors: AuthorNode[]): Author[] =>
  authors.map(({ node }) => ({
    id: node.id,
    fullName: node.userProfile.fullName,
    slug: node.userProfile.slug,
    miniBlurb: node.userProfile.miniBlurb,
    linkedin: node.userProfile.linkedin
  }))
